type When = { year: string; month: string; day: string };

export function getEarlyAchievableOffset(when: When): number | null {
  const currentDate = new Date();
  const targetDate = new Date(
    parseInt(when.year, 10),
    parseInt(when.month, 10) - 1,
    parseInt(when.day, 10)
  );

  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const targetYear = targetDate.getFullYear();
  const targetMonth = targetDate.getMonth();

  const T = (targetYear - currentYear) * 12 + (targetMonth - currentMonth);

  if (T <= 1) return null;
  if (T >= 2 && T <= 5) return 1;
  if (T >= 6 && T <= 11) return 2;
  if (T >= 12 && T <= 23) return 4;
  if (T >= 24) return 6;
  return null;
}